import { Dropdown, Avatar, Spin, Button, Space, Typography, Flex } from 'antd';
import type { MenuProps } from 'antd';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { userRoleTranslate } from 'utils/userRole';
import useUser from 'utils/useUser';
import { ThemeSwitcher } from './ThemeSwitcher';
import { makeLogoutRequest } from 'services/AuthService';
import cookies from 'utils/cookies';
import { AUTH_TOKEN } from 'constants/AppConstant';
import { useNavigate } from 'react-router-dom';

export const NavProfile = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const meRequest = useUser();
  const { mutate: logoutMutate } = useMutation({
    mutationFn: makeLogoutRequest,
    onSuccess: () => {
      queryClient.clear();
      cookies.remove(AUTH_TOKEN);
      navigate('/auth/login');
    },
  });

  const menu: MenuProps['items'] = [
    {
      key: 'profil',
      type: 'group',
      label: (
        <Spin spinning={meRequest.isLoading}>
          <Flex align="center">
            <Avatar icon={<UserOutlined />} />
            <Flex vertical style={{ marginLeft: 8 }}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                {meRequest.data?.name}
              </Typography.Title>
              <Typography.Text type="secondary">
                {meRequest.data?.role.roleName ? userRoleTranslate(meRequest.data?.role.roleName) : '-'}
              </Typography.Text>
            </Flex>
          </Flex>
        </Spin>
      ),
    },
    {
      key: 'theme-switcher',
      type: 'group',
      label: (
        <Space>
          <Typography>Ciemny motyw</Typography>
          <ThemeSwitcher />
        </Space>
      ),
    },
    {
      key: 'log-out',
      label: 'Wyloguj',
      icon: <LogoutOutlined />,
      onClick: () => logoutMutate(),
    },
  ];
  return (
    <Dropdown placement="bottomRight" menu={{ items: menu }} trigger={['click']}>
      <Button shape="circle" icon={<UserOutlined />} size="large" />
    </Dropdown>
  );
};

export default NavProfile;
